
export default fetch => ({
  changePassword (data, loading) {
    return fetch({
      url: '/api/v1/auth/ChangePassword',
      data,
      loading
    })
  },
  logout () {
    return fetch({
      url: '/api/v1/auth/Logout',
      routerCancel: false
    })
  }
})
